import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY_US } from "@/lib/constants";
import { SectionHeader } from "@/components/Services";

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-choose-us-section" className="py-24 relative">
      <div className="section-divider mb-24 max-w-7xl mx-auto" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader eyebrow="Why VR Marketing Hub" title="The reasons ambitious Indian brands pick us." desc="No fake reviews. No borrowed logos. Just a genuine promise — clear strategy, transparent work, and long-term partnership." />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {WHY_US.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Star;
            const highlight = w.title.toLowerCase().includes("ai");
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06, duration: 0.55 }}
                data-testid={`why-card-${i}`}
                className={`relative rounded-2xl p-6 glass glass-hover ${highlight ? "border-[#D4AF37]/50 shadow-[0_0_30px_rgba(212,175,55,0.15)]" : ""}`}
              >
                {highlight && (
                  <div className="absolute top-3 right-3 text-[10px] uppercase tracking-[0.2em] text-[#D4AF37] px-2 py-1 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30">Signature</div>
                )}
                <div className="w-11 h-11 rounded-xl grid place-items-center bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37] mb-4">
                  <Icon size={20} />
                </div>
                <h3 className="text-white font-semibold text-lg tracking-tight">{w.title}</h3>
                <p className="text-white/60 text-sm mt-2 leading-relaxed">{w.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
